import { useState} from "react";
// @mui
import {
  Button,
  Grid,
  CircularProgress,
  Box,
  ImageListItem,
  ImageList,
  Dialog,
  DialogTitle,
  DialogContent,
  Avatar,
  DialogActions,
  ImageListItemBar,
} from "@mui/material";
import axios from "axios";
import { getBlobsInContainer } from "src/utils/azureBlob";

// ----------------------------------------------------------------------


export default function AssetsDialog(props) {
  const [loading, setLoading] = useState(false);
  const [showAssetsType, setShowAssetsType] = useState(null);
  const [teamPlayers, setTeamPlayers] = useState([]);
  const [imageLibraryFiles, setImageLibraryFiles] = useState([]);

  const onCancel = () => {
    setShowAssetsType(null);
    props.onClose();
  };

  const loadTeamPlayers = (teamId) => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_FEED_BASE_URL}/feeds/nhl/team-players/${teamId}?token=${process.env.REACT_APP_FEED_TOKEN}`
      )
      .then(function (response) {
        let data = response.data;
        data.players = response.data.players.sort((p1, p2) =>
          p1.first_name > p2.first_name
            ? 1
            : p1.first_name < p2.first_name
            ? -1
            : 0
        );
        setTeamPlayers(data);

        setShowAssetsType("players");
        setLoading(false);
      });
  };


  const loadImageLibraryFiles = () => {
    setLoading(true);
    const fetchImages = async () => {
      const data = await getBlobsInContainer();
      setImageLibraryFiles(data);
      setShowAssetsType("image_library");
      setLoading(false);
    };

    fetchImages().catch(console.error);
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Add Asset</DialogTitle>
        <DialogContent>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: "100px 200px" }}
            >
              <CircularProgress />
            </Box>
          ) : null}
          {showAssetsType === null && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              <Grid
                item
                xs={4}
                sx={{ cursor: "pointer", p: 2 }}
                onClick={() => setShowAssetsType("teams")}
              >
                <Grid container>
                  <Grid item>
                    <Avatar
                      sx={{ width: 120, height: 120 }}
                      alt="Remy Sharp"
                      src="https://www-league.nhlstatic.com/images/logos/teams-current-primary-dark/2.svg"
                    />
                  </Grid>
                  <Grid
                    sx={{ fontSize: 14, textAlign: "center", width: "100%" }}
                  >
                    Team Logo
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} sx={{ cursor: "pointer", p: 1 }}>
                <Grid container>
                  <Grid item>
                    <Avatar
                      sx={{ width: 100, height: 100, minHeight: 120 }}
                      alt="Remy Sharp"
                      src="https://assets.nhle.com/mugs/nhl/20222023/NYI/8470601.png"
                      onClick={() => setShowAssetsType("teams_players")}
                    />
                  </Grid>
                  <Grid
                    sx={{ fontSize: 14, textAlign: "center", width: "100%" }}
                  >
                    Player Headshot
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} sx={{ cursor: "pointer", p: 1 }}>
                <Grid container>
                  <Grid
                    xs={12}
                    item
                    sx={{
                      height: 120,
                      width: 120,
                      textAlign: "center",
                      p: 4,
                    }}
                  >
                    <img
                      alt="Remy Sharp"
                      src="/assets/icons/navbar/image-outline.svg"
                      onClick={() => loadImageLibraryFiles()}
                    />
                  </Grid>
                  <Grid
                    sx={{ fontSize: 14, textAlign: "center", width: "100%" }}
                  >
                    Image Library
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : null}
          {showAssetsType === "teams" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              {teamPlayers.map((team) => (
                <Grid
                  item
                  xs={2}
                  sx={{ cursor: "pointer" }}
                  // onClick={() =>
                  //   addAssetHandler(
                  //     `https://www-league.nhlstatic.com/images/logos/teams-current-primary-dark/${team.teamId}.svg`,
                  //     team.teamName,
                  //     team.teamNameFr
                  //   )
                  // }
                >
                  <Avatar
                    sx={{ margin: "0 auto" }}
                    alt="Remy Sharp"
                    src={`https://www-league.nhlstatic.com/images/logos/teams-current-primary-dark/${team.teamId}.svg`}
                  />
                  <Box
                    sx={{
                      fontSize: 8,
                      pl: 2,
                      pr: 2,
                      pb: 1,
                      textAlign: "center",
                    }}
                  >
                    {team.teamName}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : null}
          {showAssetsType === "teams_players" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              {teamPlayers.map((team) => (
                <Grid
                  item
                  xs={2}
                  sx={{ cursor: "pointer" }}
                  onClick={() => loadTeamPlayers(team.teamId)}
                >
                  <Avatar
                    sx={{ margin: "0 auto" }}
                    alt="Remy Sharp"
                    src={`https://www-league.nhlstatic.com/images/logos/teams-current-primary-dark/${team.teamId}.svg`}
                  />
                  <Box
                    sx={{
                      fontSize: 8,
                      pl: 2,
                      pr: 2,
                      pb: 1,
                      textAlign: "center",
                    }}
                  >
                    {team.teamName}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : null}
          {showAssetsType === "players" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              {teamPlayers.players.map((player) => (
                <Grid
                  item
                  xs={2}
                  sx={{ cursor: "pointer" }}
                >
                  <Box
                    sx={{
                      fontSize: 8,
                      pl: 2,
                      pr: 2,
                      pb: 1,
                      textAlign: "center",
                    }}
                  >
                    {player.first_name} {player.last_name}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : null}
          {showAssetsType === "image_library" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              <ImageList cols={3}>
                {imageLibraryFiles.map((item, index) => (
                  <ImageListItem
                    key={index}
                    // onClick={() => addAssetHandler(item.blobUrl)}
                    sx={{ cursor: "pointer" }}
                  >
                    <img
                      src={item.blobUrl}
                      srcSet={item.blobUrl}
                      alt="library"
                      loading="lazy"
                    />
                    <ImageListItemBar title={item.blobName} subtitle={""} />
                  </ImageListItem>
                ))}
              </ImageList>
            </Grid>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
